<template>
  <div class="bread-crumbs-wrapper">
    <HomeIcon class="icon-primary fill-primary icon-offset-zero"></HomeIcon>
    <template v-for="(breadCrumb, idx) of breadCrumbs">
      <SlashForwardIcon class="icon-size-md icon-offset-zero"></SlashForwardIcon>
       <span class="bread-crumb" @click="handleNavigation(breadCrumb)" :key="idx" >
          {{ breadCrumb.name }}
        </span>
    </template>

  </div>
</template>

<script>
export default {
  name: "BreadCrumbs.vue",
  props: {
    breadCrumbs: {
      type: Array,
      required: true,
    }
  },
  methods: {
    handleNavigation(breadCrumb) {
      // If to is string, assume it's a path and navigate to it
      // If to is a function, call it
      if (typeof breadCrumb.to === 'string') {
        this.navigator.navigatePath(breadCrumb.to);
      } else if (typeof breadCrumb.to === 'function') {
        breadCrumb.to();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.bread-crumbs-wrapper {
  color: $brand-primary;
  display: flex;
  align-items: center;
  gap: $spacing-xxs;
  .bread-crumb {
    transition: all .2s ease-in-out;
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
